import { render, staticRenderFns } from "./BrandFooter.vue?vue&type=template&id=11c0e179&scoped=true&"
import script from "./BrandFooter.vue?vue&type=script&lang=js&"
export * from "./BrandFooter.vue?vue&type=script&lang=js&"
import style0 from "./BrandFooter.vue?vue&type=style&index=0&id=11c0e179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0e179",
  null
  
)

export default component.exports